import Rellax from 'rellax';
import Vivus from 'vivus/dist/vivus.min';


export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $(document).ready(function() {
      var backslider_width;
      var $window = $(window);
      var windowsize = $window.width();

      setTimeout(function() {
        var back;
        var front;

        function set_height_slider() {

          $('.boxes-carousel-one').each(function () {

            var $columns = $('.content-box', this);
            var maxHeight = Math.max.apply(Math, $columns.map(function () {
              return $(this).height();
            }).get());

            $columns.height(maxHeight);
          });

          $('.boxes-carousel-two').each(function () {

            var $columns = $('.content-box', this);
            var maxHeight = Math.max.apply(Math, $columns.map(function () {
              return $(this).height();
            }).get());

            $columns.height(maxHeight);
          });
        }

        if($('.home').length > 0) {
          $.each($('.owl-carousel'), function() {
            if($(this).hasClass('back-slider')) {
              back = $(this).owlCarousel({
                loop:true,
                margin:0,
                nav:true,
                items: 1,
                dots: true,
                autoplay: true,
                autoplayTimeout: 10000,
                mouseDrag: false,
                touchDrag: false,
              });
            } else {
              front = $('.owl-carousel').owlCarousel({
                loop:true,
                margin:0,
                nav:true,
                items: 1,
                dots: true,
                mouseDrag: false,
                touchDrag: false,
                autoplay: true,
                autoplayTimeout: 10000,
                //animateOut: 'fadeOut',
              })
            }
          });

          // Sync nav
          back.on('click', '.owl-next', function () {
            front.trigger('next.owl.carousel');
            back.trigger('next.owl.carousel');
          });

          front.on('click', '.owl-dot', function () {
            var i = $(this).index();
            back.trigger('to.owl.carousel', [i, 500, true]);
            front.trigger('to.owl.carousel', [i, 500, true]);
          });

        } else {
          $('.owl-carousel.single-slide').owlCarousel({
            loop:true,
            margin:0,
            nav:true,
            items: 1,
            dots: true,
            autoplay: true,
            autoplayTimeout: 5000,
            autoHeight: true,
            navText : ['<i class=\'fa fa-arrow-left\'></i>','<i class=\'fa fa-arrow-right\'></i>'],
          });

          $('#list-reasons-carousel').owlCarousel({
            loop:false,
            margin:0,
            nav:false,
            items: 4,
            dots: true,
            autoplay: true,
            autoplayTimeout: 3000,
            autoHeight: true,
            responsive : {
              // breakpoint from 0 up
              0 : {
                  items : 1,
              },
              // breakpoint from 480 up
              480 : {
                  items : 2,
              },
              // breakpoint from 768 up
              768 : {
                  items : 3,
              },
              992 : {
                  items : 4,
              },
            },
            navText : ['<i class=\'fa fa-arrow-left\'></i>','<i class=\'fa fa-arrow-right\'></i>'],
          });

          $('.phase-carousel').owlCarousel({
            loop:false,
            center:false,
            margin:10,
            nav:false,
            dots: false,
            URLhashListener:true,
            autoplayHoverPause:true,
            startPosition: 'URLHash',
            items : 1,
            autoHeight: true,
          });

          $('.highlights-carousel').owlCarousel({
            autoplay:true,
            loop:false,
            margin:40,
            nav: false,
            responsiveClass:true,
            dots: true,
            center: false,
            responsive:{
              0:{
                items:1,
              },
              600:{
                items:3,
              },
            },
          });

          var owl_one = $('.boxes-carousel-one');

          owl_one.owlCarousel({
            loop: false,
            center: true,
            margin: 15,
            nav: false,
            dots: true,
              autoplay: true,
              autoplayTimeout: 10000,
            items: 1,
          });

          var owl_two = $('.boxes-carousel-two');

          owl_two.owlCarousel({
            loop: false,
            center: false,
            margin: 15,
            nav: false,
            dots: true,
              autoplay: true,
              autoplayTimeout: 5000,
            items: 1,
          });

          $('.phase-carousel').on('changed.owl.carousel', function(event) {
            var id = event.item.index;
            $('.dots-slider .url').removeClass('active');
            $('.dots-slider .url[href="#slide-'+id+'"]').addClass('active');
          });

          $('.disabledrag').on('touchstart mousedown', function(e) {
            // Prevent carousel swipe
            e.stopPropagation();
          });

          set_height_slider();

          $(window).on('resize', function () {
            set_height_slider();
          });

        }

        backslider_width = $( '.back-slider' ).width();

        $( '.back-slider .owl-next' ).hover(
          function() {
            if (windowsize > 991) {
              $( '.back-slider .owl-item' ).width(backslider_width - 15);
              //console.log($( '.back-slider .owl-item' ).width() + ' before')
            }
           }, function() {
            if (windowsize > 991) {
              $( '.back-slider .owl-item' ).width(backslider_width);
              //console.log($( '.back-slider .owl-item' ).width() + ' after')
            }
           }
        );
      }, 200);

      setTimeout(function() {
       // window auto rizes

       function set_min_height() {
         $('.white-box-wrapper').each(function () {

           var $columns = $('.card-box', this);
           $columns.height('');

           var maxHeight = Math.max.apply(Math, $columns.map(function () {
             return $(this).height();
           }).get());

           // Set the height of all those children to whichever was highest
           //console.log(maxHeight);
           $columns.height(maxHeight);

           //if (windowsize > 991) {
           //    $columns.height('');
           //} else {
           //   $columns.height('');
           //   $columns.height(maxHeight);
           //}
         });

       }

       set_min_height();


       $(window).on('resize', function () {
         backslider_width = $( '.back-slider' ).width();
         // console.log(backslider_width);
         set_min_height();
       });

        new Rellax('.rellax', {
          breakpoints: [320, 768, 1200],
        });

      }, 500);


      var $hamburger = $('.hamburger');
      $hamburger.on('click', function () {
        $hamburger.toggleClass('is-active');
      });

      $('.archive-select:not(.topic-box)').click(function (e) {
        e.preventDefault();

          $('.dropdown-filter').removeClass('show area special grade org');
          $('.dropdown-filter').addClass('show');
          $('.hidden-content').removeClass('show');
          $('.overlay-click').toggleClass('d-block');


        if($(this).hasClass('school-region-box')) {
          $('.area-wrap').addClass('show');
          $('.dropdown-filter').addClass('area');
        } else if($(this).hasClass('school-key-box')) {
            $('.special-key-wrap').addClass('show');
          $('.dropdown-filter').addClass('special');
        } else if($(this).hasClass('school-grade-box')) {
            $('.grade-wrap').addClass('show');
          $('.dropdown-filter').addClass('grade');
        } else if($(this).hasClass('school-org-box')) {
            $('.org-wrap').addClass('show');
            $('.dropdown-filter').addClass('org');
        }


      });

      $('.overlay-click').click(function () {
        $('.overlay-click').toggleClass('d-block');
        $('.dropdown-filter').toggleClass('show');
        $('.dropdown-filter').removeClass('area special grade');
      });

      $('.read-more-drop').click(function(e) {
        e.preventDefault();
        $(this).prev().prev().toggleClass('expand');

        if($(this).prev().prev().hasClass('expand')) {
            // $(this).html($(this).html().replace('MORE', 'LESS'));
            // '<i class="fa fa-long-arrow-alt-down"></i>'
            $(this).html('READ LESS <i class="fa fa-arrow-up"></i>');
        } else {
            // $(this).html($(this).html().replace('LESS', 'MORE'));
            // '<i class="fa fa-long-arrow-alt-up"></i>'
            $(this).html('READ MORE <i class="fa fa-arrow-down"></i>');
        }
      });

      $('.btn-accordion').click(function() {
        $(this).find('.accor-icon').toggleClass('fa-plus fa-minus');
      });

      // $('a[href^="#"]:not(".url"):not(".read-more-drop"):not(".gotomap")').on('click', function (e) {
      //     e.preventDefault();
      //
      //     var target = this.hash,
      //
      //         $target = $(target),
      //         point = '';
      //
      //
      //     if($('body').hasClass('admin-bar')) {
      //         point = $target.offset().top - 145;
      //
      //         if($(window).width() < 601) {
      //             point = $target.offset().top - 105;
      //         }
      //
      //     } else {
      //          point = $target.offset().top - 115;
      //     }
      //
      //     $('html, body').animate({
      //         'scrollTop': point }, 500);
      //
      //     if(target == '#join-charter-form') {
      //       $('#acf-field_5dc2cf16b85d5').parent().removeClass('setFocus');
      //       $('#acf-field_5dc2cdcb2d09c').parent().addClass('setFocus');
      //     }
      //
      //     if(target == '#sign-up-form') {
      //       $('#acf-field_5dc2cdcb2d09c').parent().removeClass('setFocus');
      //       $('#acf-field_5dc2cf16b85d5').parent().addClass('setFocus');
      //     }
      //
      //     return false;
      // });

      if(window.location.hash) {
        var hash = window.location.hash;
        var $target = $(hash);

        if (hash.indexOf('slide') < 0) {
          var point = '';

          if($('body').hasClass('admin-bar')) {
            point = $target.offset().top - 145;

            if($(window).width() < 601) {
              point = $target.offset().top - 105;
            }

          } else {
            point = $target.offset().top - 115;
          }

          $('html, body').animate({
            scrollTop: point,
          }, 500); //
        }
      }

      $('#acf-field_5dc2cdcb2d09c').change(function() {
        $(this).parent().removeClass('setFocus');
      })

      $('#acf-field_5dc2cf16b85d5').change(function() {
        $(this).parent().removeClass('setFocus');
      })

        $('.select-dropdown').on('change', function() {
            this.form.submit();
        });

        $('input#click-search').change(function() {
            if(this.checked){
                $('input#search').focus();
            }
        }).change();

      function isEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/; // eslint-disable-line
        return regex.test(email);
      }

      if($('.online-donation').length > 0) {
        var amount = $('.lgld-radio[name="submission[args][field_26][suggested]"]:checked').val();

        if(amount == undefined) {
          $('#form-submit').attr('disabled', true);
          $('.lgld-list-amounts table tr:first-child label').html('<label>Amount <small><i style="color:red;">Amount is required</i></small></label>');
        } else {
          $('#form-submit').removeAttr('disabled');
          $('.lgld-list-amounts table tr:first-child label').html('<label>Amount</label>');
        }

        $('.lgld-radio[name="submission[args][field_26][suggested]"]').on('change', function() {
          if($('.lgld-radio[name="submission[args][field_26][suggested]"]:checked') == undefined) {
            $('#form-submit').attr('disabled', true);
            $('.lgld-list-amounts table tr:first-child label').html('<label>Amount <small><i style="color:red;">Amount is required</i></small></label>');
          } else {
            $('#form-submit').removeAttr('disabled');
            $('.lgld-list-amounts table tr:first-child label').html('<label>Amount</label>');
          }
        });

        $('.lgld-input-text[name="submission[args][field_9]"]').on('change', function() {
          var email = $(this).val();

          if(isEmail(email) == false) {
            $('#form-submit').attr('disabled', true);
            $('.lgld-input-text[name="submission[args][field_9]"]').prev().prev().html('<label>Email <small><i style="color:red;">You have not given a correct e-mail address</i></small></label>');
          } else {
            $('#form-submit').removeAttr('disabled');
            $('.lgld-input-text[name="submission[args][field_9]"]').prev().prev().html('<label>Email</label>');
          }
        });
      }

    });

    if($('.template-explore-school').length) {
      //if (window.location.href.indexOf('q') > -1 || window.location.href.indexOf('type') > -1) {
      //  $('html, body').animate({
      //    scrollTop: $('.filter-container').offset().top + 30,
      //  }, 500);
      //}
    }

    if($('.job-region-box').length) {
      $('.job-region-box').change(function() {
        window.location.href = window.location.protocol + '//' + window.location.host + '/job-boards?job-region-box=' + $( '.job-region-box option:selected' ).val();
      });
    }

    if($('.archive-select').length) {
      $('.archive-select').change(function() {
        if($('.post-type-archive-resumes').length) {
          window.location.href = window.location.protocol + '//' + window.location.host + '/resumes?resume-grade-box=' + $( '.resume-grade-box option:selected' ).val() + '&job-type-box=' +  $( '.job-type-box option:selected' ).val()  + '&resume-content-box=' +  $( '.resume-content-box option:selected' ).val();
        } else if ($('.post-type-archive-job-board').length) {
          window.location.href = window.location.protocol + '//' + window.location.host + '/job-boards?job-status-box=' + $( '.job-status-box option:selected' ).val() + '&grade-level-box=' +  $( '.grade-level-box option:selected' ).val()  + '&job-type-box=' +  $( '.job-type-box option:selected' ).val();
        }
      });
    }

    if($('#filter-type').length) {
      $('.dd-item-active').contents().get(0).nodeValue = $('.dd-item[data-selected="true"]').text();


      $('#filter-type').click(function() {
        $('#filter-type').find('.dd-options').toggleClass('show');
        $('.overlay-click').toggleClass('d-block');
      });

      $('.dd-item').click(function() {
        $('.dd-item').attr('data-selected', false);
        $(this).attr('data-selected', true);
        $('.dd-item-active').contents().get(0).nodeValue = $(this).text();
      });

      $( '#filter-rs' ).submit(function(e) {
        e.preventDefault();

        var q = $('#q').val();
        var page_name = $('.posttype-name').text();
        var selected_resources = $('.dd-item[data-selected="true"]').attr('data-value');
        window.location.href = window.location.protocol + '//' + window.location.host + '/'+ page_name +'?q=' + q + '&type=' + selected_resources;
      });
    }

    if($('.template-donor-wall').length) {
        new Vivus('moving-svg-1', {
          type: 'sync',
          start: 'autostart',
          duration: 350,
        });

        const book = new Vivus('moving-svg-4', {
            type: 'sync',
            start: 'manual',
            duration: 350,
            animTimingFunction: Vivus.EASE,
        });

        const btm_heart = new Vivus('moving-svg-3', {
            type: 'sync',
            duration: 350,
            start: 'manual',
            animTimingFunction: Vivus.EASE,
        });

        var scrolltop = $(document).scrollTop();
        var top_book = $('#moving-svg-4').offset().top - 400;
        var played_book = false;
        var top_heart = $('#moving-svg-3').offset().top - 400;
        var played_heart = false;

        $( document ).scroll(function() {
            scrolltop = $(document).scrollTop();

            if((scrolltop >= top_book) && (played_book === false)) {
                book.play();
                played_book = true;
            }

            if((scrolltop >= top_heart) && (played_heart === false)) {
                btm_heart.play();
                played_heart = true;
            }
        });

        $('.gotomap').click(function(e) {
          e.preventDefault();
            $('html, body').animate({
                scrollTop: $('#section-map-region').offset().top,
            }, 1000, function() {
                // Callback after animation
                // Must change focus!
                var $target = $('#section-map-region');
                $target.focus();
                if ($target.is(':focus')) { // Checking if the target was focused
                    return false;
                } else {
                    $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                    $target.focus(); // Set focus again
                }
            });
        })
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js